export const BUSINESS = {
  name: "Delta Grassmasters",
  suffix: "LLC",
  tagline: "Commercial Landscape Construction & Maintenance",
  phone: "(501) 803-9005",
  phoneHref: "tel:+15018039005",
  email: "info@deltagrassmasters.com",
  address: "23114 Highway 365, North Little Rock, AR 72113",
  hours: "8:00 a.m. – 4:30 p.m., Monday – Friday",
  mapEmbed:
    "https://www.google.com/maps?q=23114+Highway+365+North+Little+Rock+AR+72113&output=embed",
  mapLink:
    "https://www.google.com/maps?q=23114+Highway+365+N+Maumelle,+AR&zip=72113-9146",
};

export const LOGO_URL = `${process.env.PUBLIC_URL}/logo-emblem.png`;
export const LOGO_FULL_URL = `${process.env.PUBLIC_URL}/logo-full.png`;

export const IMAGES = {
  heroExcavator:
    "https://images.unsplash.com/photo-1503708928676-1cb796a0891e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920&ixlib=rb-4.1.0",
  forkliftSod:
    "https://images.unsplash.com/photo-1774291635063-898534da7c82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  skidSteer:
    "https://images.unsplash.com/photo-1763515187478-9934edce7158?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  bulldozer:
    "https://images.unsplash.com/photo-1652303713917-2666b8bee507?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  concreteWork:
    "https://images.unsplash.com/photo-1707655536176-a2bc5e00cba9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  rooftopGreenery:
    "https://images.unsplash.com/photo-1748187614555-c5305bd35692?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  crew:
    "https://images.unsplash.com/photo-1652303518379-c0ef1c9fb2b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&ixlib=rb-4.1.0",
  sprinklers:
    "https://images.unsplash.com/photo-1770664945615-52203ab54c88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  mower:
    "https://images.unsplash.com/photo-1637269820082-d4ad72e2ad75?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  mowingMan:
    "https://images.unsplash.com/photo-1734303023491-db8037a21f09?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  stripedLawn:
    "https://images.unsplash.com/photo-1625766924110-efbb2db1d1d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
  corporateLawn:
    "https://images.unsplash.com/photo-1571805477040-23a9fe4a2758?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&ixlib=rb-4.1.0",
  leafTexture:
    "https://images.pexels.com/photos/7506193/pexels-photo-7506193.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const FEATURES = [
  {
    title: "Licensed, Bonded & Insured",
    body: "Fully credentialed across Arkansas and Mississippi, so property managers can build with total confidence.",
  },
  {
    title: "Commercial-Focused Expertise",
    body: "We work at the scale of schools, campuses, and infrastructure — not weekend yards.",
  },
  {
    title: "Latest Horticultural Practices",
    body: "Our crews are trained in modern turf science, irrigation, and construction methods.",
  },
  {
    title: "No Job Too Small or Large",
    body: "From a single French drain to a full campus install, we scope and deliver reliably.",
  },
];

export const SERVICES = {
  construction: {
    label: "01 — Landscape Construction & Management",
    heading: "Landscape Construction & Management",
    image: "bulldozer",
    items: [
      {
        name: "Landscapes",
        desc: "Full design and installation of commercial landscapes built to spec and to last.",
      },
      {
        name: "Irrigation Systems",
        desc: "Design, installation, and maintenance of efficient commercial irrigation.",
      },
      {
        name: "Hydro-Seeding",
        desc: "Fast, uniform turf establishment across large properties and graded sites.",
      },
      {
        name: "French Drains",
        desc: "Engineered drainage solutions that protect buildings, lots, and green space.",
      },
      {
        name: "Construction Management",
        desc: "End-to-end landscape construction management for infrastructure projects.",
      },
      {
        name: "Heavy Equipment",
        desc: "Use of all types of heavy equipment to move ground and deliver on schedule.",
      },
    ],
  },
  turf: {
    label: "02 — Turf Service & Grooming",
    heading: "Turf Service & Grooming",
    image: "mower",
    items: [
      {
        name: "Chemical Treatments",
        desc: "Targeted applications that keep commercial turf healthy season after season.",
      },
      {
        name: "Fertilizing",
        desc: "Balanced fertilization programs tuned to your property and soil.",
      },
      {
        name: "Weed Control",
        desc: "Proactive weed management for clean, professional grounds.",
      },
      {
        name: "Leaf Blowing",
        desc: "Reliable clean-up that keeps walkways, lots, and entrances presentable.",
      },
      {
        name: "Irrigation Maintenance",
        desc: "Ongoing inspection and repair to keep every zone running right.",
      },
      {
        name: "Spring Start-Up Irrigation",
        desc: "Seasonal system activation and calibration for a strong growing season.",
      },
    ],
  },
};

export const MANIFESTO = [
  {
    num: "01",
    title: "Rooted in the Delta",
    body: "Delta Grassmasters started in the heart of Arkansas' lower Mississippi Delta Region in Helena, Arkansas — and we carry that work ethic to every commercial site we touch.",
  },
  {
    num: "02",
    title: "Licensed Across Two States",
    body: "We are licensed for landscaping construction and maintenance in Arkansas and Mississippi. Licensed, bonded, and insured.",
  },
  {
    num: "03",
    title: "Client Focused, Every Scale",
    body: "We provide top quality service to all of our clients. No job is too small or large.",
  },
  {
    num: "04",
    title: "Trained on the Latest",
    body: "Our staff is trained with the latest techniques and services of landscaping. We specialize in the latest horticultural practices and landscapes.",
  },
];
